export default "__VITE_ASSET__CKpMyOtf__"